import type {
  LngLat,
  VectorCustomizationItem,
  YMapLocationRequest,
} from 'ymaps3';
import settings from '~/widgets/Map/model/config/map-settings.json';

import { ParkingIcon } from '~/entities/ParkingIcon/ParkingIcon';
import { FC, useEffect, useState } from 'react';
import P from 'public/icons/P.svg?react';
import { Search } from '~/pages/MainPage/model/useMainPageStore';
import { Reactify } from '@yandex/ymaps3-types/reactify';

//import { useGeoLocation } from '~/shared/hooks/useGeolocation';

interface Props {
  reactify: Reactify;
  main: boolean;
  openPlaces?: (id: string | number) => void;
  markers?: { coordinates: LngLat; count: number; id: string | number }[];
  searchLocation?: LngLat;
  searchZoom?: number;
  setSearch?: (search: Search) => void;
}

export const Map: FC<Props> = ({
  openPlaces,
  //  setSearch,
  reactify,
  main,
  markers,
  searchLocation,
  searchZoom,
}) => {
  // const { coords, isLoading } = useGeoLocation(true);

  const LOCATION: YMapLocationRequest = {
    center: markers?.length ? markers[0].coordinates : [37.613198, 55.758493],
    zoom: markers ? 12 : 10,
    duration: 1500,
  };

  const { YMap, YMapDefaultSchemeLayer, YMapMarker, YMapDefaultFeaturesLayer } =
    reactify.module(ymaps3);

  const [location, setLocation] = useState<YMapLocationRequest>(LOCATION);

  useEffect(() => {
    searchLocation &&
      setLocation({
        ...location,
        center: searchLocation,
        zoom: searchZoom ?? 10,
      });
  }, [searchLocation]);

  return (
    <div style={{ width: '100%', height: main ? '100vh' : '160px' }}>
      {
        <YMap location={location} mode={'vector'}>
          <YMapDefaultSchemeLayer
            customization={reactify.useDefault(
              settings as VectorCustomizationItem[]
            )}
          />
          <YMapDefaultFeaturesLayer />

          {main &&
            markers?.map(({ coordinates, id }, i) => {
              return (
                <YMapMarker
                  coordinates={coordinates}
                  key={i}
                  onClick={
                    openPlaces &&
                    (() => {
                      openPlaces(id);
                      // setSearch?.({
                      //   address: '',
                      //   lat: coordinates[0],
                      //   lon: coordinates[1],
                      // });
                    })
                  }>
                  <ParkingIcon content={'P'} />
                </YMapMarker>
              );
            })}
          {!main &&
            markers?.map(({ coordinates }, i) => {
              return (
                <YMapMarker coordinates={coordinates} key={i}>
                  <ParkingIcon content={<P width={12} height={18} />} />
                </YMapMarker>
              );
            })}
        </YMap>
      }
    </div>
  );
};
